import angular from "angular";

import { CustomerInvoice, CustomerInvoiceListItem, CustomerInvoices } from "@salaxy/core";

import { UiHelpers } from "../../services";
import { ApiCrudObjectController } from "../bases";

/**
 * Controller for listing and browsing Customer Usecases.
 * NOTE: Access save / modify methods is very restricted by design as invoces are created by Palkkaus and cannot be modified by the Customer.
 * Typically, you will not be able to save / delete / modify customer invoices in the production environment.
 */
export class CustomerInvoiceCrudController extends ApiCrudObjectController<CustomerInvoice, CustomerInvoiceListItem> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "CustomerInvoices",
    "UiHelpers",
    "$location",
    "$routeParams",
  ];

  /**
   * Creates a new DatasetsCrudController
   * @ignore
   */
  constructor(
    fullApi: CustomerInvoices,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any,
  ) {
    super(fullApi, uiHelpers, $location, $routeParams);
  }

  /**
   * Controller initialization
   */
  public $onInit() {
    super.$onInit();
  }

  /** Implements the getDefaults of ApiCrudObjectController */
  public getDefaults() {
    return {
      listUrl: this.listUrl || "/customer-invoices/",
      detailsUrl: this.detailsUrl || "/customer-invoices/details/",
      // TODO: Add a custom listing
      oDataTemplateUrl: "salaxy-components/odata/lists/CustomerInvoices.html",
      oDataOptions: {},
    };
  }
}